import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service'

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../../shared/showmenu.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MenucontentService } from '../../../shared/menucontent.service';

@Component({
  selector: 'app-mass-start-done',
  templateUrl: './mass-start-done.component.html',
  styleUrls: ['./mass-start-done.component.css'],
})
export class MassStartDoneComponent implements OnInit {
  event_id: string;
  event_name: string;
  event_starter: string;
  event_start_time: any;

  restart_race() {
    localStorage.setItem('current_mass_start_id', this.event_id);
    localStorage.setItem('current_mass_start_name', this.event_name);

    this.router.navigate(['/mass-start/' + this.event_name]);
  }

  goto_finishline() {
    if (localStorage.getItem('global_input_method') == 'scan') {
      this.router.navigateByUrl('/scan/Finish Line');
    } else {
      this.router.navigateByUrl('/type/Finish Line');
    }
  }

  constructor(
    private menutitle: MenutitleService,
    private AuthenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private ShowmenuService: ShowmenuService,
    private MenucontentService: MenucontentService
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()
    this.AuthenticationService.save_current_route()
    
    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.menutitle.changeMenutitle('Start a race');
    this.menutitle.showMenupink(false);

    this.route.paramMap.subscribe((params) => {
      this.event_name = params.get('event_name');
      this.event_id = params.get('event_id');

      var start_json_array = {};
      start_json_array = JSON.parse(localStorage.getItem('global_start_json'));

      this.event_starter = start_json_array[this.event_id][1];

      var start_time = start_json_array[this.event_id][0];
      var date = new Date(start_time * 1000);

      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

      this.event_start_time =
        date.getDate() +
        ' ' +
        months[date.getMonth()] +
        ' ' +
        date.getFullYear() +
        ' ' +
        date.getHours() +
        'h' +
        date.getMinutes() +
        ':' +
        date.getSeconds();
    });
  }
}

/*
var timestamp = 1301090400,
date = new Date(timestamp * 1000),
datevalues = [
   date.getFullYear(),
   date.getMonth()+1,
   date.getDate(),
   date.getHours(),
   date.getMinutes(),
   date.getSeconds(),
];
*/
